export default function Space({ size }) { 

  return (
    <div className={size}></div>
  )

}